import {
  faSearchMinus,
  faChevronDown,
  faChevronUp
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Row, Container, Collapse } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import { labeledActiveFilters } from "../../../services/FilteringUtils";
import CommonUtil, { is } from "../../../utils/CommonUtil";
import DropDown from "../DropDown";
import ProcessComponent from "../ProcessComponent";
import Share from "../Share";
import SubmitButton from "../SubmitButton/SubmitButton";
import SubmitControl from "../SubmitControl/SubmitControl";
const ComponentHeader = ({
  title,
  id,
  addProcesses,
  onAdd,
  deleteProcesses,
  onDelete,
  advancedSearchParametersExist,
  onAdvancedSearch,
  onAdvancedSearchDelete,
  activeFilter,
  activeProcesses,
  onActiveFilterChange,
  onSearchChange,
  searchValue,
  onSearch,
  showBackButton,
  showShareButton,
  size = "xs", // variants:  xs  |  sm  |  md  |  lg
  joint = false, // if set to true, title and tools will be arranged in one row
  flat = false, // if joint property is false & flat is true too, collapsible header will be shown,
  messageHandler,
  shareMailSubject
}) => {
  const showBack = showBackButton && window.history.length > 1;
  const showTitle = is(title);
  const showSearch = is(onSearchChange);
  const showAdd = is(onAdd);
  const showDelete = is(onDelete) && activeFilter !== labeledActiveFilters[1];
  const showAS = is(onAdvancedSearch);
  const showASDelete =
    is(advancedSearchParametersExist) && is(onAdvancedSearchDelete);
  const buttonsCount = CommonUtil.countEquals(
    true,
    showAdd,
    showDelete,
    showAS,
    showASDelete,
    showShareButton
  );
  const showButtons = buttonsCount > 0;
  const showActive = is(onActiveFilterChange);

  const titleColumnSize = showSearch
    ? "col-6 col-sm-auto"
    : "col-auto flex-grow-1";
  const titleClass = `d-flex align-items-center ${titleColumnSize}`;

  var activeXS = 0;

  if (
    !joint ||
    (showTitle && (!showButtons || !showSearch)) ||
    (!showTitle && !showButtons && !showSearch)
  ) {
    activeXS = 12;
  } else {
    activeXS = 12 - Math.ceil(buttonsCount * 1.5);
  }

  var buttonsClass = "flex-grow-0";
  if (showTitle && showButtons && showActive && !showSearch) {
    buttonsClass += " searchColMargin tableButtonsTopRow";
  } else {
    buttonsClass += " tableButtons" + !joint ? " tableButtonsBottomRow" : "";
  }

  const showDividedBottomRow =
    (joint && showTitle) || showBack || showSearch || showButtons || showActive;

  var tableLabelClass =
    showTitle && !showSearch && !showButtons && !showActive
      ? "tableLabel d-flex flex-grow-1"
      : "tableLabel tableLabelBottom d-flex flex-grow-1";
  tableLabelClass += !joint || !showDividedBottomRow ? " tableLabelMargin" : "";

  const bottomRowClass =
    "tableHeaderRow d-flex flex-grow-1" + !joint && !flat
      ? " table-header-bottom-row"
      : "";

  var titleSize = "medium";
  switch (size) {
    case "xs":
      titleSize = "small";
      break;
    case "sm":
      titleSize = "medium";
      break;

    case "lg":
      titleSize = "larger";
      break;
    case "md":
    default:
      titleSize = "large";
      break;
  }
  const titleStyle = { fontSize: titleSize };

  const [open, setOpen] = React.useState(true);

  return (
    <div className="tableHeader d-flex align-items-center">
      <Container className="table-header-container">
        {!joint && showTitle ? (
          <Row
            className="tableHeaderRow header-top-row-margin d-flex flex-grow-1 tableHeaderRowHover"
            style={{ marginRight: 0 }}
            noGutters
            onClick={() => setOpen(!open)}
            aria-controls="collapsable"
            aria-expanded={open}
          >
            <Col
              className={tableLabelClass}
              sm="auto"
              xs="auto"
              style={titleStyle}
            >
              <div className="d-flex align-items-center">
                <div>{CommonUtil.constructHeaderTitleAndId(title, id)}</div>
              </div>
            </Col>
            {showDividedBottomRow ? (
              <Col
                sm="auto"
                xs="auto"
                className="table-header-toggle-button d-flex flex-grow-0"
              >
                <SubmitButton
                  size={size}
                  isSubmit={false}
                  transparent
                  icon={
                    open ? (
                      <FontAwesomeIcon icon={faChevronUp} />
                    ) : (
                      <FontAwesomeIcon icon={faChevronDown} />
                    )
                  }
                />
              </Col>
            ) : null}
          </Row>
        ) : null}

        {showDividedBottomRow ? (
          <Collapse in={open}>
            <div id="collapsable">
              <Row
                className={bottomRowClass}
                style={{ marginRight: 0 }}
                noGutters
              >
                {joint && showTitle ? (
                  <div className={titleClass}>
                    <Col className={tableLabelClass} style={titleStyle}>
                      <div className="d-flex align-items-center">
                        {showBack ? (
                          <SubmitButton
                            type="back"
                            className="headerBackButton"
                            transparent
                            size={size}
                          />
                        ) : null}{" "}
                        <div>
                          {CommonUtil.constructHeaderTitleAndId(title, id)}
                        </div>
                      </div>
                    </Col>{" "}
                  </div>
                ) : showBack ? (
                  <SubmitButton type="back" size={size} />
                ) : null}

                {showSearch ? (
                  <Col
                    className="searchColMargin flex-grow-1"
                    sm={{ span: "auto" }}
                    xs={!joint ? "auto" : "6"}
                  >
                    <SubmitControl
                      disableable={false}
                      type="search"
                      placeholder={labels.search}
                      onChange={onSearchChange}
                      value={searchValue}
                      onSearch={onSearch}
                      size={size}
                    />
                  </Col>
                ) : !joint ? (
                  <Col className=" flex-grow-1"></Col>
                ) : null}

                {showButtons ? (
                  <Col
                    className={buttonsClass}
                    sm={{ span: "auto" }}
                    xs={{ span: "auto" }}
                  >
                    {showAdd ? (
                      <SubmitButton
                        type="create"
                        onClick={onAdd}
                        processes={addProcesses}
                        size={size}
                      />
                    ) : null}
                    {showDelete ? (
                      <SubmitButton
                        type="delete"
                        onClick={onDelete}
                        text={labels.deleteButtonDescription}
                        processes={deleteProcesses}
                        showLoader={false}
                        size={size}
                      />
                    ) : null}
                    {showAS ? (
                      <SubmitButton
                        type="search"
                        onClick={onAdvancedSearch}
                        text={labels.advancedSearch}
                        size={size}
                      />
                    ) : null}
                    {showASDelete ? (
                      <Button
                        className="buttonStyle"
                        title={labels.advancedSearchParamsDelete}
                        onClick={onAdvancedSearchDelete}
                        size={size}
                      >
                        <FontAwesomeIcon icon={faSearchMinus} />
                      </Button>
                    ) : null}
                    {showShareButton ? (
                      <Share
                        size={size}
                        messageHandler={messageHandler}
                        mailSubject={shareMailSubject}
                      />
                    ) : null}
                  </Col>
                ) : null}

                {showActive ? (
                  <ProcessComponent processes={activeProcesses}>
                    <Col
                      className={activeXS < 12 ? "flex-grow-1" : "flex-grow-0"}
                      xs={activeXS === 12 ? "12" : "auto"}
                      sm="2"
                      md="3"
                      xl="3"
                      lg="2"
                      style={{ paddingRight: 0 }}
                    >
                      <DropDown
                        value={activeFilter}
                        options={labeledActiveFilters.map(x => ({
                          value: x,
                          label: x.label
                        }))}
                        onChange={onActiveFilterChange}
                        processes={activeProcesses}
                        size={size}
                      />
                    </Col>
                  </ProcessComponent>
                ) : null}
              </Row>
            </div>
          </Collapse>
        ) : null}
      </Container>
    </div>
  );
};

export default ComponentHeader;
